import React from "react";
import styled from "styled-components";
import {
  FaAward,
  FaCoins,
  FaTrophy,
  FaInfoCircle,
  FaExclamationTriangle,
} from "react-icons/fa";

export interface UIDirective {
  type: string;
  message: string;
}

const ToastContainer = styled.div<{ background: string; borderColor: string }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-left: 4px solid ${(props) => props.borderColor};
  background: ${(props) => props.background};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-family: "Segoe UI", sans-serif;
`;

const ToastMessage = styled.span`
  font-size: 15px;
  color: #333;
  line-height: 1.4;
`;

const UIDirectiveToast: React.FC<{ directive: UIDirective }> = ({ directive }) => {
  const { type, message } = directive;

  let icon = <FaInfoCircle size={20} color="#555" />;
  let borderColor = "#cccccc";
  let background = "#ffffff";

  switch (type) {
    case "badges":
      icon = <FaAward size={22} color="#8a6d3b" />;
      borderColor = "#f0ad4e";
      background = "#fcf8e3";
      break;
    case "point":
      icon = <FaCoins size={22} color="#155724" />;
      borderColor = "#28a745";
      background = "#d4edda";
      break;
    case "challenge":
      icon = <FaTrophy size={22} color="#004085" />;
      borderColor = "#007bff";
      background = "#cce5ff";
      break;
    case "warning":
      icon = <FaExclamationTriangle size={22} color="#856404" />;
      borderColor = "#ffc107";
      background = "#fff3cd";
      break;
    default:
      icon = <FaInfoCircle size={20} color="#555" />;
      borderColor = "#cccccc";
      background = "#f8f9fa";
  }

  return (
    <ToastContainer background={background} borderColor={borderColor}>
      {icon}
      <ToastMessage>{message}</ToastMessage>
    </ToastContainer>
  );
};

export default UIDirectiveToast;
